import { jsx as _jsx } from "react/jsx-runtime";
import { Text, TextSize } from '@as/cotopaxi';
import { HtmlInclude } from '../../common/html-include/HtmlInclude';
export const ProductCareDescription = ({ description }) => (_jsx(Text, { size: TextSize.SMALL, children: _jsx(HtmlInclude, { htmlFragment: description }) }));
